import { defineMessages, useIntl } from 'react-intl';

import { Tabs } from '../../Shared/Tabs';
import { PeopleWithAccess } from './PeopleWithAccess';
import { PreviewMembers } from './PreviewMembers';
import type { PeopleWithAccessProps, PreviewMembersProps } from './ShareModal';
import { SoftPinCollection } from './SoftPinCollection';

type ShareModalContentProps =
  | ({
      view: 'previewMembers';
    } & PreviewMembersProps)
  | ({
      view: 'peopleWithAccess';
    } & PeopleWithAccessProps);

const messages = defineMessages({
  shareCollection: {
    defaultMessage: 'Share Collection',
    id: 'xj+IYa',
  },
});

export function ShareModalContent({
  config,
  ...props
}: {
  config?: string;
} & ShareModalContentProps) {
  const { formatMessage } = useIntl();
  if (config === 'challenge' && props.view === 'peopleWithAccess') {
    return <PeopleWithAccess config={config} {...props} />;
  } else {
    if (props.view === 'peopleWithAccess') {
      return (
        <Tabs
          tabs={[
            {
              id: 'shareCollection',
              title: formatMessage(messages.shareCollection),
              content: (
                <>
                  <PeopleWithAccess {...props} />
                  <SoftPinCollection
                    isPinned={props.isPinned}
                    onIsPinnedChange={props.onIsPinnedChange}
                    isLoading={props.isLoading}
                  />
                </>
              ),
            },
          ]}
          selectedTab="shareCollection"
          onTabChange={() => {}}
        />
      );
    }
  }
  return <PreviewMembers {...props} />;
}
